"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StickyRightBar = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _Grid = _interopRequireDefault(require("../Grid"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _styles = require("./styles");

var _styles2 = require("@material-ui/core/styles");

var _deprecated = _interopRequireDefault(require("prop-types-extra/lib/deprecated"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var StickyRightBar = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(StickyRightBar, _Component);

  var _super = _createSuper(StickyRightBar);

  function StickyRightBar() {
    var _this;

    (0, _classCallCheck2.default)(this, StickyRightBar);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "render", function () {
      var _this$props = _this.props,
          id = _this$props.id,
          classes = _this$props.classes,
          className = _this$props.className,
          children = _this$props.children,
          rightBar = _this$props.rightBar,
          rightBarProps = _this$props.rightBarProps,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["id", "classes", "className", "children", "rightBar", "rightBarProps"]);
      return /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({
        id: "".concat(id, "-stickyRightBar"),
        className: (0, _classnames.default)("prmbl-stickyRightBarContainer", className, classes.root),
        container: true,
        spacing: 24
      }, otherProps), /*#__PURE__*/_react.default.createElement(_Grid.default, {
        item: true,
        xs: 12,
        md: 8,
        lg: 9,
        xl: 10,
        className: (0, _classnames.default)("prmbl-stickyRightBarContentContainer")
      }, children), /*#__PURE__*/_react.default.createElement(_Grid.default, (0, _extends2.default)({
        item: true,
        xs: 12,
        md: 4,
        lg: 3,
        xl: 2,
        className: (0, _classnames.default)("prmbl-StickyRightBar", classes.rightBar)
      }, rightBarProps), rightBar));
    });
    return _this;
  }

  return StickyRightBar;
}(_react.Component);

exports.StickyRightBar = StickyRightBar;
(0, _defineProperty2.default)(StickyRightBar, "propTypes", {
  /**
   * The html id
   */
  id: _propTypes.default.string.isRequired,

  /**
   * @ignore
   *
   * Utilizing this to style up the page don't want to expose this in the style guide.
   * Auto-populated by material-ui withStyles()
   */
  classes: _propTypes.default.object.isRequired,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The content that will be in the right bar.
   */
  rightBar: _propTypes.default.node,

  /**
   * The content that will be in the main area.
   */
  children: _propTypes.default.node,

  /**
   * @ignore
   * Whether the topbar is fixed
   */
  fixedTopBar: (0, _deprecated.default)(_propTypes.default.bool, "This StickyRightBar uses the deprecated `fixedTopBar` prop. Remove this prop, the position sticky is now relative to the viewable page content area."),

  /**
   * Props to pass on to the right bar
   */
  rightBarProps: _propTypes.default.object
});
(0, _defineProperty2.default)(StickyRightBar, "defaultProps", {
  className: ""
});

var _default = (0, _styles2.withStyles)(_styles.styles)(StickyRightBar);

exports.default = _default;